import React from 'react';
// import macieklogo from '../../assets/octopus.png';
import styles from './Logo.css';

const Logo = (props) => (
    <div className={styles.logo}>
        {/*<img src={macieklogo} alt="Logo"/>*/}
        <p><span>MACIEK</span>LEWANDOWSKI</p>
    </div>
);

export default Logo;


// WEBPACK FOOTER //
// ./src/components/Logo/Logo.js